import { Module } from '@nestjs/common'
import { LoggerModule } from 'nestjs-pino'
import { pinoLoggerConfig } from './default.logger'

@Module({
	providers: [],
	imports: [
		LoggerModule.forRoot({
			pinoHttp: { ...pinoLoggerConfig },
		}),
	],
	exports: [LoggerModule],
})
export class LoggingModule {}
